import { Dialog, DialogContent, IconButton, Tooltip } from '@material-ui/core';
import MessageOutlinedIcon from '@material-ui/icons/MessageOutlined';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import { useEffect, useState } from 'react';
import NoteList from './NoteList';
import { useGetEntityNotesQuery } from './notesSlice';
import { NotesStyle } from './style';

const NotesTooltip = ({ notes, entityId, entityType, editPermissionProfile, readOnly = false }) => {

    let { data: notesFromApi, error: notesError, isFetching: isLoadingNotes } = useGetEntityNotesQuery({ entityId: entityId, entityType: entityType }, { skip: !entityId || !!notes });

    const noteData = notes ?? notesFromApi ?? [];

    const classes = NotesStyle();
    const [listOpen, setListOpen] = useState(false);

    useEffect(() => {
    }, []);

    return (
        <Authorize profile={permissionProfiles.NOTES.VIEW_NOTES}>
            {!!noteData?.length ?
                <Tooltip title={`Click to view ${noteData?.length} notes`}>
                    <IconButton size='small' onClick={() => setListOpen(true)} className={`${classes.notesTooltipOn} ${classes.notesTooltip}`}>
                        <MessageOutlinedIcon />
                    </IconButton>
                </Tooltip> :
                !readOnly &&
                <Authorize profile={permissionProfiles.NOTES.EDIT_NOTES}>
                    <Tooltip title={'Add notes'}>
                        <IconButton size='small' onClick={() => setListOpen(true)} className={`${classes.notesTooltipOff} ${classes.notesTooltip}`}>
                            <MessageOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Authorize>
            }
            <Dialog open={listOpen} onClose={() => setListOpen(false)} >
                <DialogContent >
                    <NoteList
                        notes={noteData}
                        collapsible={false}
                        entityId={entityId}
                        entityType={entityType}
                        editPermissionProfile={editPermissionProfile}
                        readOnly={readOnly}
                    />
                </DialogContent>
            </Dialog>
        </Authorize>
    );
}
export default NotesTooltip;